import { PropsWithChildren } from "react"
import { classes } from "@tm/utils"
import { BoxProps } from "@mui/material"
import { TableVariants } from "../interfaces"
import { TableRowComponent } from "./TableRowComponent"
import { TableRowShadow } from "./TableRowShadow"
import { ROWCAP, SMALL_ROWCAP } from "../configs"

type TableRowProps = PropsWithChildren<{
    colCount: number
    active?: boolean
    onClick?: () => void
    onDoubleClick?: () => void
    rowIndicatorColor?: string
    rowCap?: number
    variant?: TableVariants
    singleRow?: boolean
    transparent?: boolean
    transparentHighlight?: boolean
    rowStyles?: React.CSSProperties
    sx?: BoxProps["sx"]
}>

export function TableRow(props: TableRowProps) {
    return (
        <TableRowComponent
            className={classes("Table-row", "row", props.active && "row-active")}
            colCount={props.colCount}
            active={!!props.active}
            onClick={() => props.onClick?.()}
            onDoubleClick={() => props.onDoubleClick?.()}
            rowIndicatorColor={props.rowIndicatorColor}
            singleRow={props.singleRow}
            transparent={props.transparent}
            transparentHighlight={props.transparentHighlight}
            style={props.rowStyles}
            sx={props.sx}
        >
            {props.children}

            <TableRowShadow
                colCount={props.colCount}
                rowCap={(props.rowCap ?? props.variant === "small") ? SMALL_ROWCAP : ROWCAP}
                active={props.active}
                variant={props.variant}
                rowIndicatorColor={props.rowIndicatorColor}
                transparent={props.transparent}
            />
        </TableRowComponent>
    )
}
